import React from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

type MainHeaderProps = {
  title: React.ReactNode;
  rightButton?: {
    label: string;
    link: string;
  };
};

export const MainHeader = (props: MainHeaderProps) => {
  const history = useHistory();

  const canGoBack = history.length > 1;

  const { title, rightButton } = props;
  return (
    <div className="d-flex align-items-center mb-4">
      {/* Back button */}
      <Button
        className="back-button me-2"
        color={'link'}
        onClick={() => history.goBack()}
        disabled={!canGoBack}
      >
        <FaChevronLeft />
      </Button>

      <h1 className="ms-1 me-auto mb-0">{title}</h1>

      {/* Right button */}
      {rightButton && (
        <Link to={rightButton.link}>
          <Button color="primary" size="s">
            {rightButton.label}
          </Button>
        </Link>
      )}
    </div>
  );
};
